"use strict";

exports.__esModule = true;
exports.setTrimLine = exports.setTransmissionType = exports.setSummaryExpand = exports.setSummaryDocked = exports.setPackages = exports.setModel = exports.setIncompatibleCodes = exports.setFuelType = exports.setFabric = exports.setDriveType = exports.setDataLossModal = exports.setColor = exports.setChangeModelModal = exports.setAccessories = exports.resetPreferences = exports.clearAllPreferences = void 0;
var setColor = exports.setColor = function setColor(value) {
  return {
    type: 'configurator/SET_COLOR',
    value: value
  };
};
var setFabric = exports.setFabric = function setFabric(value) {
  return {
    type: 'configurator/SET_FABRIC',
    value: value
  };
};
var setFuelType = exports.setFuelType = function setFuelType(value) {
  return {
    type: 'configurator/SET_FUEL_TYPE',
    value: value
  };
};
var setDriveType = exports.setDriveType = function setDriveType(value) {
  return {
    type: 'configurator/SET_DRIVE_TYPE',
    value: value
  };
};
var setTransmissionType = exports.setTransmissionType = function setTransmissionType(value) {
  return {
    type: 'configurator/SET_TRANSMISSION_TYPE',
    value: value
  };
};
var clearAllPreferences = exports.clearAllPreferences = function clearAllPreferences(value) {
  return {
    type: 'configurator/CLEAR_ALL_PREFERENCES',
    value: value
  };
};
var setModel = exports.setModel = function setModel(value) {
  return {
    type: 'configurator/SET_MODEL',
    value: value
  };
};
var setTrimLine = exports.setTrimLine = function setTrimLine(value) {
  return {
    type: 'configurator/SET_TRIM_LINE',
    value: value
  };
};
var setPackages = exports.setPackages = function setPackages(value) {
  return {
    type: 'configurator/SET_PACKAGES',
    value: value
  };
};
var setAccessories = exports.setAccessories = function setAccessories(value) {
  return {
    type: 'configurator/SET_ACCESSORIES',
    value: value
  };
};
var setIncompatibleCodes = exports.setIncompatibleCodes = function setIncompatibleCodes(value) {
  return {
    type: 'configurator/SET_INCOMPATIBLECODES',
    value: value
  };
};
var setSummaryExpand = exports.setSummaryExpand = function setSummaryExpand(value) {
  return {
    type: 'configurator/SET_SUMMARY_EXPAND',
    value: value
  };
};
var setSummaryDocked = exports.setSummaryDocked = function setSummaryDocked(value) {
  return {
    type: 'configurator/SET_SUMMARY_DOCKED',
    value: value
  };
};
var setDataLossModal = exports.setDataLossModal = function setDataLossModal(value, step) {
  return {
    type: 'configurator/SET_DATA_LOSS_MODAL',
    value: value,
    step: step
  };
};
var setChangeModelModal = exports.setChangeModelModal = function setChangeModelModal(value) {
  return {
    type: 'configurator/SET_CHANGE_MODEL_MODAL',
    value: value
  };
};
var resetPreferences = exports.resetPreferences = function resetPreferences() {
  return {
    type: 'configurator/RESET_OPTIONS'
  };
};